import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 999,

        /* 🔥 LIGHT TRANSPARENT BACKGROUND */
        background: "rgba(0,0,0,0.15)",

        /* 🔥 GLASS EFFECT */
        backdropFilter: "blur(6px)",

        padding: "10px 0",
      }}
    >
      <div
        className="container-fluid content"
        style={{
          paddingLeft: "40px",
          paddingRight: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        
        {/* LOGO */}
        <a className="navbar-brand" href="#">
          <img
            src="/home1/assets/img/logo_dark.png"
            alt=""
            style={{
              height: "60px",
              filter: "brightness(0) invert(1)",
            }}
          />
        </a>

        {/* RIGHT ICON */}
        <div className="nav-side">
          <a
            href="#"
            className="icon side_menu_btn"
            style={{
              color: "#fff",
              fontSize: "32px",  // 🔥 reduced (45 was too big)
            }}
          >
            <i className="la la-grip-lines"></i>
          </a>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;
